import { View, Text } from "react-native";
import { StatusIndicatorType } from "./interfaces";

interface Props {
  status: StatusIndicatorType;
  statusTitle?: string;
}

const statusColorMap = {
  active: "text-success-700 bg-success-0",
  warning: "text-warning-700 bg-warning-50",
  draft: "text-warning-700 bg-warning-50",
  danger: "text-error-800 bg-error-0",
};

export default function StatusIndicator({ status, statusTitle }: Props) {
  const statusColor = statusColorMap[status] || "text-gray-600";

  return (
    <View>
      <Text
        className={`text-xs py-0.5 px-2 rounded capitalize self-start font-medium ${statusColor}`}
      >
        {statusTitle ?? status}
      </Text>
    </View>
  );
}
